import { render, staticRenderFns } from "./secretaryEdit.vue?vue&type=template&id=058018e6&scoped=true&"
import script from "./secretaryEdit.vue?vue&type=script&lang=js&"
export * from "./secretaryEdit.vue?vue&type=script&lang=js&"
import style0 from "./secretaryEdit.vue?vue&type=style&index=0&id=058018e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058018e6",
  null
  
)

export default component.exports